import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';  

declare function unescape(s:string): string;

// Imports Terceros
//import * as CryptoJS from 'crypto-js';
import { Blowfish } from 'javascript-blowfish';

@Injectable()
export class UtilsService {

	/**
	* @constructor
	*/
  constructor() { }

  /**
  * @desc Encode string to base64 UTF-8
  */
  public utf8ToBase64(value: string): string {
  	return window.btoa(unescape(encodeURIComponent(value)));
  }

  /**
	* @desc Fill values with character specific
	* @param {String} valueFirst
	* @param {String} valueLast
	* @param {String} charToPut
	* @param {Number} toLimit
	* @return {String}
	*/
	public padBetweenValues(valueFirst: string, valueLast: string, charToPut: string, toLimit: number): any {
		valueFirst = valueFirst.toString();
		valueLast = valueLast.toString();
		let difference = toLimit - (valueFirst.length + valueLast.length);
	  let buildString = difference > 0 ? charToPut.repeat(difference) : "";
		return valueFirst + "" + buildString + "" + valueLast;
	}

	/**
	* @desc Get value params
	* @param {String} name
	* @param {String} url
	* @return {Any}
	*/
	public gup(name: string, url: string): any {
	    if (!url) url = location.href;
	    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
	    let regexS = "[\\?&]"+name+"=([^&#]*)";
	    let regex = new RegExp( regexS );
	    let results = regex.exec( url );
	    return results == null ? null : results[1];
	}

	/**
	* @desc Get all value params in json
	* @param {String} qs
	* @return {JSON}
	*/
	public getQueryParams(qs: string): any{
	    qs = qs.split('+').join(' ');

	    let params = {};
	    let tokens;
	    let re = /[?&]?([^=]+)=([^&]*)/g;

	    while (tokens = re.exec(qs)) {
	        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
	    }
	    return params;
	}

	/**
	* @desc Get value without blank spaces
	* @param {String} value
	* @return {String}
	*/
	public removeBlankSpacesString(value:string): string {
		if (value) {
			return value.replace(/\s/g, '');
		} else {
			return null;
		}
	}

	public decryptInfo(text: string, key?: string): string {
		key = key || this.getGenericKeyEncription();
		const bf = new Blowfish(key);
		const text64 = bf.base64Decode(text);
		const res = bf.decrypt(text64);
		return bf.trimZeros(res);
  }

  public base64Decode(text: string) {
  	if (!text) return null;
  	//text = this.cleanString(text);
  	return atob(text);
  }

  public cleanString(input) {
  	let output = "";
    for (let i=0; i<input.length; i++) {
      if (
      	input.charCodeAt(i) != 4 &&
      	input.charCodeAt(i) != 65533
      ) output += input.charAt(i);      
    }
    return output;
  }

  private getGenericKeyEncription(): string {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const fullKey = String(year) + (month <= 9 ? '0' + month : String(month)) + (day <= 9 ? '0' + day : String(day));
    return fullKey + fullKey;
  } 

  public queryStringToJSONObject(queryString: string) {
      if(queryString.indexOf('?') > -1) queryString = queryString.split('?')[1];
      var pairs = queryString.split('&');
      var result = {};
      pairs.forEach((pair) => {
        const splitPair = pair.split('=');
        result[splitPair[0]] = decodeURIComponent(splitPair[1] || '');
      });
      return result;
  }

	/*******************************************************************************
	* Entrust TruePass 8.0
	*/

	/**
	 * Utiliza las políticas de seguridad para verificar la contraseña
	 */
	public validatePassword(oldPassword, newPassword, confirmationPassword): any {
		let message = null;
    if (newPassword != confirmationPassword) {
     	console.error('Se produjo un error estableciendo la contraseña', 'La contraseña nueva no es igual a la confirmación');
      return false;
    } else {      
      // Constantes para las políticas de seguridad
      const MIN_LENGTH_CONTRASENA = 6;
      const MIN_NUM_CHAR_ALFA = 2;
      const MIN_NUM_CHAR_NUMBER = 1;
      const MAX_NUM_CHAR_REP = 5;
      //const MIN_NUM_CARAC_DIF = 2;

      let checkSizePassword = this.passwordCheckLength(newPassword, MIN_LENGTH_CONTRASENA);
      if (!checkSizePassword) message = "La longitud mínima de la contraseña es de " + MIN_LENGTH_CONTRASENA + " carácteres";
      
      let checkNumCharAlfa = this.checkMinNumberAlpha(newPassword, MIN_NUM_CHAR_ALFA);
      if (!checkNumCharAlfa) message = "El número mínimo de carácteres alfabéticos es " + MIN_NUM_CHAR_ALFA;
      
      let checkNumCharNumber = this.checkMinNumberDigitsEsp(newPassword, MIN_NUM_CHAR_NUMBER);
      if (!checkNumCharNumber) message = "El número mínimo de carácteres numéricos y especiales es " + MIN_NUM_CHAR_NUMBER;
      
      let verificarCarRep = this.checkRepeatedChar(newPassword, MAX_NUM_CHAR_REP);
      if (!verificarCarRep) message = "El número máximo de carácteres repetidos es " + MAX_NUM_CHAR_REP;
      
      if (oldPassword) {
        let verificarContrasenaDif = this.passwordCheckReusePassword(oldPassword, newPassword);
        if (!verificarContrasenaDif) message = "La contraseña anterior y la nueva contraseña son iguales";
      }
      
      if (message) {
       	console.error('Se produjo un error estableciendo la contraseña', message);
        return {
        	mensaje: message,
        	respuesta: false
        };
      }
    }
    return {
      mensaje: message,
      respuesta: true
    };
	}

	private passwordCheckLength(newPassword, minLength) {
		// Password length check
		return newPassword && newPassword.length < minLength ? false : true;
	}

	/*public passwordCheckUpperCase(newPassword) {
		// Uppercase check
		return newPassword == newPassword.toLowerCase() ? false : true;
	}

	public passwordCheckLowerCase(newPassword) {
		// Lowercase check
		return newPassword == newPassword.toUpperCase() ? false : true;
	}

	public passwordCheckNumericChar(newPassword) {
		// Numeric check
		return newPassword.match(/[0-9]+/g) == null ? false : true;
	}*/

	private checkMinNumberDigitsEsp(newPassword, num) {
		// Verifica que el carácter especial o numérico aparezca por lo menos el número de veces indicado
	  let exprReg = new RegExp("([^A-Za-z]|[0-9]){" + num + ",}");
		return exprReg.test(newPassword);
	}

	private checkMinNumberAlpha(newPassword, num) {
		// Verifica que el carácter alfabético aparezca por lo menos el número de veces indicado
	  let exprReg = new RegExp("([A-Za-z]){" + num + ",}");
		return exprReg.test(newPassword);
	}

	// No se puede repetir un carácter más del número de veces específicado
	public checkRepeatedChar(newPassword, lengthLimit) {
		let rule7Broken = newPassword && newPassword.length == 0;
		let repeatLimit = lengthLimit;
		let repeatCount = 1;

		if (!newPassword) return;

		for (let index = 0; index <= (newPassword.length - 1); index++) {	  	
			// compare the two neighbour characters
			if (newPassword.charAt(index) == newPassword.charAt(index + 1)) {
				repeatCount++;
				if (repeatCount >= repeatLimit)	{
					rule7Broken = true;
					break;
				}
			} else repeatCount = 1;
		}
		return rule7Broken ? false : true;
	}

	/*private passwordCheckNonAlphaNumericChar(newPassword) {
		// Numeric check
		return newPassword.match(/[^A-Za-z0-9]+/g) == null ? false : true;
	}*/

	private passwordCheckReusePassword(oldPassword, newPassword) {
		// Password reuse check
		return (newPassword.length == 0 || oldPassword.length == 0 ||
			newPassword.indexOf(oldPassword) != -1) ? false : true;
	}

	/*private passwordCheckProfileUse(newPassword, currentUserName) {
		// Cannot contain a portion of profile name longer than half its length
		const rule6Broken = (newPassword.length == 0);
		const lengthLimit = Math.round(newPassword.length/2);
		for (index = 0; index <= (newPassword.length - lengthLimit); index++)	{
			// take a portion of the password
			let portion = newPassword.substring(index, index + lengthLimit);
			// Check if the portion can be found in the user name.
			if (currentUserName.indexOf(portion) != -1) {
				rule6Broken = true;
				break;
			}
		}
		return rule6Broken ? false : true;
	}

	private passwordCheckRepeatChar(newPassword) {
		// Cannot repeat a character more than half the length of the password
		const rule7Broken = (newPassword.length == 0);
		const repeatLimit = lengthLimit;
		let repeatCount = 1;
		for (index = 0; index <= (newPassword.length - 1); index++)	{
			//------------------------------------------------------------------
			// compare the two neighbour characters
			if (newPassword.charAt(index) == newPassword.charAt(index + 1))	{
				repeatCount++;
				if (repeatCount > repeatLimit) {
					rule7Broken = true;
					break;
				}
			}	else repeatCount = 1;
		}
		return rule7Broken ? false : true;
	}

	private passwordCheckPasswordMatch(newPassword, confirmPassword) {
		// Password match check
		return newPassword.length == 0 || newPassword != confirmPassword ? false : true;
	}	*/


	public quitarAcentos(input: string): string {
	  const tittles: string = "áàäéèëíìïóòöúùuñÁÀÄÉÈËÍÌÏÓÒÖÚÙÜÑçÇ";
    const original: string = "aaaeeeiiiooouuunAAAEEEIIIOOOUUUNcC";
    for (let i = 0; i < tittles.length; i++) {
      input = input.replace(tittles.charAt(i), original.charAt(i)).toLowerCase();
    };
    return input;
	} 

	public stringToB64(str, widthEncodeUri?: boolean) {
    let strEncode = null;
    strEncode = widthEncodeUri ? encodeURIComponent(str) : str;
	  return window.btoa(strEncode);
	}

  private getKeyEncription() {    
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const fullKey = String(year) + (month <= 9 ? '0' + month : String(month)) + (day <= 9 ? '0' + day : String(day));
    return fullKey + fullKey;    
  }
 
  public encryptAES(message: string): string {
    const keyGenerated = this.getKeyEncription();
    let _key = CryptoJS.enc.Utf8.parse(keyGenerated);
    let _iv = CryptoJS.enc.Utf8.parse(keyGenerated);
    let encrypted = CryptoJS.AES.encrypt(message, _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/services/utils.service.ts